var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectNoComm = function SvgIconSubjectNoComm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-subj-no-comm",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M260.021 88.322h-10.666a6.77 6.77 0 0 0 1.014 3.605l1.95 3.055-1.95 3.055a6.77 6.77 0 0 0-1.014 3.6h10.666a6.77 6.77 0 0 0-1.014-3.6l-1.95-3.055 1.95-3.055a6.77 6.77 0 0 0 1.014-3.605Z",
    transform: "translate(-247.688 -86.974)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M252.021 90.986h5.334c0 1.471-2.667 2.664-2.667 2.664s-2.667-1.193-2.667-2.664Z",
    transform: "translate(-247.688 -86.974)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M251.355 101.455c0-1.472 1.492-2.664 3.333-2.664s3.333 1.192 3.333 2.664Z",
    transform: "translate(-247.688 -86.974)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 14,
    height: 1.498,
    rx: 0.724,
    transform: "translate(0 14.502)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 14,
    height: 1.498,
    rx: 0.724,
    fill: "#a0a0a0"
  }))));
};
export { SvgIconSubjectNoComm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWJqLW5vLWNvbW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogICAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI2YyZjJmMiIgb3BhY2l0eT0iMCIvPgogICAgPGcgaWQ9Imljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMikiPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzU5IiBkYXRhLW5hbWU9IlBhdGggNTkiCiAgICAgICAgICAgICAgZD0iTTI2MC4wMjEsODguMzIySDI0OS4zNTVhNi43Nyw2Ljc3LDAsMCwwLDEuMDE0LDMuNjA1bDEuOTUsMy4wNTUtMS45NSwzLjA1NWE2Ljc3LDYuNzcsMCwwLDAtMS4wMTQsMy42aDEwLjY2NmE2Ljc3LDYuNzcsMCwwLDAtMS4wMTQtMy42bC0xLjk1LTMuMDU1LDEuOTUtMy4wNTVBNi43Nyw2Ljc3LDAsMCwwLDI2MC4wMjEsODguMzIyWiIKICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQ3LjY4OCAtODYuOTc0KSIgZmlsbD0iI2ViZWJlYiIvPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzYwIiBkYXRhLW5hbWU9IlBhdGggNjAiCiAgICAgICAgICAgICAgZD0iTTI1Mi4wMjEsOTAuOTg2aDUuMzM0YzAsMS40NzEtMi42NjcsMi42NjQtMi42NjcsMi42NjRTMjUyLjAyMSw5Mi40NTcsMjUyLjAyMSw5MC45ODZaIgogICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDcuNjg4IC04Ni45NzQpIiBmaWxsPSIjZmZjZTAwIi8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfNjEiIGRhdGEtbmFtZT0iUGF0aCA2MSIKICAgICAgICAgICAgICBkPSJNMjUxLjM1NSwxMDEuNDU1YzAtMS40NzIsMS40OTItMi42NjQsMy4zMzMtMi42NjRzMy4zMzMsMS4xOTIsMy4zMzMsMi42NjRaIgogICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDcuNjg4IC04Ni45NzQpIiBmaWxsPSIjZmZjZTAwIi8+CiAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8zIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAzIiB3aWR0aD0iMTQiIGhlaWdodD0iMS40OTgiIHJ4PSIwLjcyNCIKICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDE0LjUwMikiIGZpbGw9IiNhMGEwYTAiLz4KICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzQiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxLjQ5OCIgcng9IjAuNzI0IiBmaWxsPSIjYTBhMGEwIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";